// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L0brLYR3ZZ6wm4 {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 12px));
  margin: 24px 0 36px;
  column-gap: 16px;
  row-gap: 16px;
}
@media only screen and (max-width: 1280px) {
  .L0brLYR3ZZ6wm4 {
    grid-template-columns: repeat(3, calc(33.3% - 10px));
  }
}
@media only screen and (min-width: 751px) and (max-width: 900px) {
  .L0brLYR3ZZ6wm4 {
    grid-template-columns: repeat(2, calc(50% - 8px));
  }
}
@media only screen and (max-width: 750px) {
  .L0brLYR3ZZ6wm4 {
    grid-template-columns: max(100%, 120px);
  }
}
._Z77oZI8Js6UKR {
  display: grid;
  grid-row: auto / span 2;
  grid-template-rows: subgrid;
  row-gap: 0;
}
.PD2q9JE6PRa2mr {
  height: 100%;
}
.Y5gCeeJLz0bHCg {
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.vccO4XHqldnulB {
  margin-top: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTileList": `L0brLYR3ZZ6wm4`,
	"listItem": `_Z77oZI8Js6UKR`,
	"newCreateTile": `PD2q9JE6PRa2mr`,
	"loadMoreFooter": `Y5gCeeJLz0bHCg`,
	"closedBoardsFooter": `vccO4XHqldnulB`
};
export default ___CSS_LOADER_EXPORT___;
